// Feature/payment-method-update | October 14th 2025: Simple controller to toggle between update button and payment method options panels
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "options"]

  showOptions() {
    this.buttonTarget.classList.add('is-hidden')
    this.optionsTarget.classList.remove('is-hidden')
  }

  showButton() {
    this.optionsTarget.classList.add('is-hidden')
    this.buttonTarget.classList.remove('is-hidden')
  }
}

